export default "__VITE_ASSET__BbRd2rvT__"